import useCurrentUser from "@/hooks/useCurrentUser";

const fetcher = (url: string) => fetch(url).then((res) => res.json());

export function useAdminStatus() {
  const { currentUser } = useCurrentUser();

  const isUserAdmin = currentUser?.role === "elevated";

  return { isUserAdmin };
}

export default useAdminStatus;
